import { useMutation, useQueryClient } from "@tanstack/react-query"
import { requestSellerRevisionAdminToBuyerQuotation } from "@/lib/api/quotation.api"
import { useAuthStore } from "@/store/auth.store"

export function useRequestSellerRevision() {
  const accessToken = useAuthStore((s) => s.accessToken)
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (id: string) => {
      if (!accessToken) throw new Error("Not authenticated")
      return requestSellerRevisionAdminToBuyerQuotation(id, accessToken)
    },
    onSuccess: (_data, id) => {
      queryClient.invalidateQueries({ queryKey: ["admin-buyer-quotation-detail", id] })
      queryClient.invalidateQueries({ queryKey: ["admin-buyer-quotations"] })
    },
  })
}
